import * as React from 'react'

import Svg, { Circle, Path } from 'react-native-svg'

import { IconProps } from '../icons'

const LowInterestRates = ({
  size = 40,
  color = '#000',
  ...props
}: IconProps) => (
  <Svg
    width={`${size}px`}
    height={`${size}px`}
    fill="none"
    viewBox="0 0 40 40"
    {...props}
  >
    <Circle cx={20} cy={20} r={20} fill="#fff" />
    <Path
      d="m5.394 23.07 9.804 10.743a.57.57 0 0 0 .842 0l5.738-6.287a9.844 9.844 0 0 0 2.874.428c5.574 0 10.11-4.651 10.11-10.369 0-5.717-4.536-10.369-10.11-10.369a9.853 9.853 0 0 0-4.986 1.352h-8.249a.584.584 0 0 0-.576.591v2.366c0 .326.258.591.576.591a.584.584 0 0 0 .577-.591V9.75h6.042a10.461 10.461 0 0 0-3.494 7.835c0 4.241 2.496 7.895 6.06 9.5l-4.983 5.458-8.474-9.286h4.272a.584.584 0 0 0 .577-.591v-5.819a.584.584 0 0 0-.577-.591.584.584 0 0 0-.576.591v5.227H5.815c-.23 0-.438.14-.529.356a.603.603 0 0 0 .108.64Zm10.301-5.485c0-5.065 4.018-9.186 8.957-9.186 4.938 0 8.956 4.12 8.956 9.186 0 5.065-4.018 9.186-8.956 9.186-4.939 0-8.957-4.12-8.957-9.186Z"
      fill="#5BC7E2"
    />
    <Path
      d="M11.417 13.595a.584.584 0 0 0-.577.59c0 .328.259.592.577.592a.584.584 0 0 0 .577-.591.584.584 0 0 0-.577-.591ZM32.45 17.586c0-4.41-3.498-7.999-7.798-7.999s-7.799 3.588-7.799 7.999c0 4.41 3.499 7.998 7.799 7.998 4.3 0 7.798-3.588 7.798-7.998Zm-14.444 0c0-3.759 2.981-6.816 6.646-6.816 3.664 0 6.645 3.057 6.645 6.816 0 3.758-2.98 6.815-6.645 6.815-3.665 0-6.646-3.057-6.646-6.815Z"
      fill="#5BC7E2"
    />
    <Path
      d="M26.097 19.008c-.69.677-.69 1.78 0 2.457.336.329.782.51 1.258.51.475 0 .921-.181 1.257-.51a1.715 1.715 0 0 0 0-2.457 1.784 1.784 0 0 0-1.257-.51c-.476 0-.922.18-1.258.51Zm1.676.813a.58.58 0 0 1 0 .83.595.595 0 0 1-.418.17.595.595 0 0 1-.419-.17.58.58 0 0 1 0-.83c.112-.11.26-.17.419-.17.157 0 .306.06.418.17ZM23.724 14.934c0-.444-.172-.89-.518-1.228a1.784 1.784 0 0 0-1.257-.51c-.475 0-.922.18-1.258.51-.69.677-.69 1.78 0 2.457.336.329.783.51 1.258.51s.922-.181 1.257-.51c.346-.339.518-.784.518-1.229Zm-2.194.416a.58.58 0 0 1 0-.83c.112-.11.26-.171.419-.171.158 0 .306.06.418.17a.58.58 0 0 1 0 .83.594.594 0 0 1-.418.171.594.594 0 0 1-.419-.17ZM21.092 20.259a.566.566 0 0 0 .002.815.602.602 0 0 0 .836-.002l6.282-6.16a.567.567 0 0 0-.003-.816.602.602 0 0 0-.836.002l-6.281 6.16Z"
      fill="#5BC7E2"
    />
  </Svg>
)

export default LowInterestRates
